// image-processing-loader
var previousRequest = require("!!../../../../../../node_modules/fox-file-loader/index.js!../../../../../../node_modules/file-loader/index.js?name=[path][name].[ext]!./btn_yellow.png");
var dir = previousRequest.replace("btn_yellow.png", "")
module.exports = require("!../../../../../../node_modules/fox-image-optimize-plugin/router.js")({
	dir: dir,
	base: "btn_yellow.png",
	name: "btn_yellow",
	ext: ".png",
	query: ""
}, previousRequest);


//////////////////
// WEBPACK FOOTER
// ./images/bg/btn_yellow.png
// module id = 1010
// module chunks = 4